import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface MotorReadingFilters {
  deviceId?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
  mode?: 'graph';
}

@Injectable({
  providedIn: 'root'
})
export class MotorService {
  constructor(private http: HttpClient) {}

  getDevices(): Observable<any> {
    return this.http.get('motor/devices');
  }

  getReadings(filters?: MotorReadingFilters): Observable<any> {
    let params = new HttpParams();

    if (filters && filters.deviceId && filters.deviceId !== 'all') {
      params = params.set('deviceId', filters.deviceId);
    }

    if (filters && filters.from) {
      params = params.set('from', filters.from);
    }

    if (filters && filters.to) {
      params = params.set('to', filters.to);
    }

    if (filters && filters.limit != null) {
      params = params.set('limit', String(filters.limit));
    }

    if (filters && filters.offset != null) {
      params = params.set('offset', String(filters.offset));
    }

    if (filters && filters.mode) {
      params = params.set('mode', filters.mode);
    }

    return this.http.get('motor/readings', { params: params });
  }

  getDashboardSummary(filters?: {
    deviceId?: string;
    from?: string;
    to?: string;
  }): Observable<any> {
    let params = new HttpParams();

    if (filters && filters.deviceId && filters.deviceId !== 'all') {
      params = params.set('deviceId', filters.deviceId);
    }

    if (filters && filters.from) {
      params = params.set('from', filters.from);
    }

    if (filters && filters.to) {
      params = params.set('to', filters.to);
    }

    return this.http.get('motor/dashboard/summary', { params: params });
  }

  getAnalytics(filters: {
    deviceId: string;
    from?: string;
    to?: string;
  }): Observable<any> {
    let params = new HttpParams();

    params = params.set('deviceId', filters.deviceId);

    if (filters && filters.from) {
      params = params.set('from', filters.from);
    }

    if (filters && filters.to) {
      params = params.set('to', filters.to);
    }

    return this.http.get('motor/analytics', { params: params });
  }
  getThresholds(deviceId: string) { return this.http.get(`motor/thresholds`, { params: { deviceId } }); }
saveThresholds(body: any)       { return this.http.post(`motor/thresholds`, body); }
getAlerts(filters: any)         { return this.http.get(`motor/alerts`, { params: filters }); }
ackAlert(id: number)            { return this.http.post(`motor/alerts/${id}/ack`, {}); }
}